/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ kind: "added" | "removed" | "swapped", before: NonNullable<unknown>, after: NonNullable<unknown> }} Plan_History_ItemInputs */

const en_us2_plan_history_item = /** @type {(inputs: Plan_History_ItemInputs) => LocalizedString} */ (i) => {
	if (i?.kind === "swapped") return /** @type {LocalizedString} */ (`Swapped ${i?.before} for ${i?.after}`);
	if (i?.kind === "added") return /** @type {LocalizedString} */ (`Added ${i?.after}`);
	if (i?.kind === "removed") return /** @type {LocalizedString} */ (`Removed ${i?.before}`);
	return /** @type {LocalizedString} */ ("plan.history_item");
};

const pt_br2_plan_history_item = /** @type {(inputs: Plan_History_ItemInputs) => LocalizedString} */ (i) => {
	if (i?.kind === "swapped") return /** @type {LocalizedString} */ (`Trocou ${i?.before} por ${i?.after}`);
	if (i?.kind === "added") return /** @type {LocalizedString} */ (`Adicionou ${i?.after}`);
	if (i?.kind === "removed") return /** @type {LocalizedString} */ (`Removeu ${i?.before}`);
	return /** @type {LocalizedString} */ ("plan.history_item");
};

const es_419_plan_history_item = /** @type {(inputs: Plan_History_ItemInputs) => LocalizedString} */ (i) => {
	if (i?.kind === "swapped") return /** @type {LocalizedString} */ (`Cambió ${i?.before} por ${i?.after}`);
	if (i?.kind === "added") return /** @type {LocalizedString} */ (`Agregó ${i?.after}`);
	if (i?.kind === "removed") return /** @type {LocalizedString} */ (`Quitó ${i?.before}`);
	return /** @type {LocalizedString} */ ("plan.history_item");
};

const pt_pt2_plan_history_item = /** @type {(inputs: Plan_History_ItemInputs) => LocalizedString} */ (i) => {
	if (i?.kind === "swapped") return /** @type {LocalizedString} */ (`Trocou ${i?.before} por ${i?.after}`);
	if (i?.kind === "added") return /** @type {LocalizedString} */ (`Adicionou ${i?.after}`);
	if (i?.kind === "removed") return /** @type {LocalizedString} */ (`Removeu ${i?.before}`);
	return /** @type {LocalizedString} */ ("plan.history_item");
};

const fr_fr2_plan_history_item = /** @type {(inputs: Plan_History_ItemInputs) => LocalizedString} */ (i) => {
	if (i?.kind === "swapped") return /** @type {LocalizedString} */ (`${i?.before} remplacé par ${i?.after}`);
	if (i?.kind === "added") return /** @type {LocalizedString} */ (`${i?.after} ajouté`);
	if (i?.kind === "removed") return /** @type {LocalizedString} */ (`${i?.before} retiré`);
	return /** @type {LocalizedString} */ ("plan.history_item");
};

const de_de2_plan_history_item = /** @type {(inputs: Plan_History_ItemInputs) => LocalizedString} */ (i) => {
	if (i?.kind === "swapped") return /** @type {LocalizedString} */ (`${i?.before} gegen ${i?.after} getauscht`);
	if (i?.kind === "added") return /** @type {LocalizedString} */ (`${i?.after} hinzugefügt`);
	if (i?.kind === "removed") return /** @type {LocalizedString} */ (`${i?.before} entfernt`);
	return /** @type {LocalizedString} */ ("plan.history_item");
};

const it_it2_plan_history_item = /** @type {(inputs: Plan_History_ItemInputs) => LocalizedString} */ (i) => {
	if (i?.kind === "swapped") return /** @type {LocalizedString} */ (`Ha sostituito ${i?.before} con ${i?.after}`);
	if (i?.kind === "added") return /** @type {LocalizedString} */ (`Ha aggiunto ${i?.after}`);
	if (i?.kind === "removed") return /** @type {LocalizedString} */ (`Ha rimosso ${i?.before}`);
	return /** @type {LocalizedString} */ ("plan.history_item");
};

/**
* | kind | output |
* | --- | --- |
* | "swapped" | "Swapped {before} for {after}" |
* | "added" | "Added {after}" |
* | "removed" | "Removed {before}" |
*
* @param {Plan_History_ItemInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_history_item = /** @type {((inputs: Plan_History_ItemInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_History_ItemInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_history_item(inputs)
	if (locale === "es-419") return es_419_plan_history_item(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_history_item(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_history_item(inputs)
	if (locale === "de-DE") return de_de2_plan_history_item(inputs)
	if (locale === "it-IT") return it_it2_plan_history_item(inputs)
	return en_us2_plan_history_item(inputs)
});
export { plan_history_item as "plan.history_item" }